import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  standalone: false,
    selector   : 'footer',
    templateUrl: './footer.component.html',
    styleUrls  : ['./footer.component.scss']
})
export class FooterComponent
{

    public appVersion = environment.version;
    public logoecute = environment.logoProductUrl;

    public sponsorImages: string[] = environment['sponsorsImages'] || [];

    /**
     * Constructor
     */
    constructor()
    {
    }

}
